<template>
    <div v-if="FormMemberships">
        <NewDocument v-if="FormMemberships" :chart-record-id="ChartRecordId" :form-memberships-import="FormMemberships" :NewDocPayload="NewDocPayload"/>
    </div>
</template>

<script>
    import NewDocument from '../Core/RecordComponents/NewDocument.vue';

    export default {
        name: "EmbedNewDocument",
        props: [

        ],
        data: function () {
            return {
                FormMemberships: null,
                NewDocPayload: {},
            }
        },
        methods: {
            GetFormMemberships() {
                this.$MasterAPI.ExecuteRequest("GET", "GenMod/Options/FormMemberships", { ChartId: this.ChartRecordId, ChartType: "ClientSubProgramMembership" }, this.GetFormMembershipsSuccess, null, true);
            },
            GetFormMembershipsSuccess(response) {
                this.FormMemberships = response.data.data;

            }
            
        },
        components: {
            NewDocument
        },
        computed: {
            ChartRecordId: function () {
                return this.$route.query.ChartRecordId
            },
        },
        mounted: function () {
            this.NewDocPayload = {
                Intent: this.$route.query.intent,
                FormID: this.$route.query.formid,
                DateOfService: this.$route.query.dateofservice,
                StartTime: this.$route.query.starttime,
                EndTime: this.$route.query.endtime,
                ServiceName: this.$route.query.servicename,
            }
            //this.$router.replace({ query: { ChartRecordId: this.$route.query.ChartRecordId } });
            this.GetFormMemberships();
        }
    }
</script>